// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1oxAM","title":"BackImages_title__3lYlG","images":"BackImages_images__2lcgP"};